import { List } from '@material-ui/core'
import { TFunction } from 'i18next'
import { FC } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { updateApplicationStatus } from '../../../actions/applications'
import { UpdateApplicationStatus } from '../../../actions/types'
import { NestedList } from '../../../components/Display'
import { selectIsAdminUser } from '../../../selectors/users'
import { Application } from '../../../types/applications'
import { StateInterface } from '../../../types/states'
import { formatToReadableDate } from '../../../utils/dates'
import { bindSubmitActionToPromise } from '../../../utils/forms'
import UpdateApplicationStatusFrom from '../../Application/Forms/UpdateApplicationStatusForm'
import {
  applicationInformationOrder,
  getApplicationDataWithTranslations,
  applicationInformationOrderAdmin
} from '../values/handleApplicationsData'

interface OwnProps {
  applications: Application[]
  t: TFunction
}

interface StateProps {
  isAdmin: boolean
}
interface DispatchProps {
  updateApplicationStatus: UpdateApplicationStatus
}

type ApplicationsListProps = OwnProps & DispatchProps & StateProps

const ApplicationsList: FC<ApplicationsListProps> = ({
  t,
  applications,
  updateApplicationStatus,
  isAdmin
}) => (
  <List component='nav'>
    {applications &&
      applications.map((application: Application) => {
        const { applicationId, status, message, createdAt } = application
        const readableCreatedAt = formatToReadableDate(
          createdAt,
          'HH:MM dd.mm.yyyy'
        )
        const data = getApplicationDataWithTranslations(application, isAdmin)
        const listItemText = `${data.name} - +${data.phone} - ${
          data.email
        } - ${t(`application.status.${status}`)} - ${readableCreatedAt}`
        return (
          <NestedList
            key={applicationId}
            t={t}
            translationPath='application.list.'
            id={applicationId}
            listItemText={listItemText}
            data={data}
            listName='applicationsList'
            informationOrder={
              isAdmin
                ? applicationInformationOrderAdmin
                : applicationInformationOrder
            }
            splitIntoTwoColumns
            Form={
              <UpdateApplicationStatusFrom
                t={t}
                title='apartment.adminInfo.button'
                applicationId={applicationId}
                updateApplicationStatus={updateApplicationStatus}
                initialValues={{
                  message,
                  applicationId
                }}
              />
            }
          />
        )
      })}
  </List>
)

const mapStateToProps = (state: StateInterface) => ({
  isAdmin: selectIsAdminUser(state)
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateApplicationStatus: bindSubmitActionToPromise(
    dispatch,
    updateApplicationStatus
  )
})

export default connect<StateProps, DispatchProps, OwnProps, StateInterface>(
  mapStateToProps,
  mapDispatchToProps
)(ApplicationsList)
